<template>
  <div class="mr-2">
    <UserDropdown name-class="text-sm font-medium" logout-redirect="/" />
  </div>
</template>

<script lang="ts" setup>
import UserDropdown from '@/components/UserDropdown.vue';
</script>
